import { initializeSentry } from './sentry';

initializeSentry();
